import axios from "axios";
import store from "../src/store";
const apiClient = axios.create({
  baseURL: "https://beta.kpay.ao",
  withCredentials: false,
  validateStatus: () => true,
  headers: {
    Accept: "Application/json",
    "Sys-Client": "Application/kwp"
  }
});

const bufferPDF = axios.create({
  baseURL: "https://beta.kpay.ao",
  withCredentials: false,
  validateStatus: () => true,
  responseType: "arraybuffer",
  headers: {
    Accept: "Application/json",
    "Sys-Client": "Application/kwp"
  }
});

const bufferCSV = axios.create({
  baseURL: "https://beta.kpay.ao",
  withCredentials: false,
  validateStatus: () => true,
  responseType: "arraybuffer",
  headers: {
    Accept: "Application/json",
    "Sys-Client": "Application/kwp"
  }
});

const clientFormData = axios.create({
  baseURL: "https://beta.kpay.ao",
  withCredentials: false,
  headers: {
    Accept: "Application/json",
    "Content-Type": "multipart/form-data",
    "Sys-Client": "Application/kwp"
  }
});

// const clientFormData = axios.create({
//   baseURL: "http://localhost:8001",
//   withCredentials: false,
//   headers: {
//     Accept: "Application/json",
//     "Content-Type": "multipart/form-data"
//   }
// });

// const test = axios.create({
//   baseURL: "http://localhost:8001",
//   withCredentials: false,
//   validateStatus: () => true,
//   headers: {
//     Accept: "Application/json"
//   }
// });

export default {
  customizeHeader(token) {
    // test.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    clientFormData.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    bufferPDF.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    bufferCSV.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    return (apiClient.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${token}`);
  },
  interceptionRoute() {
    return apiClient.interceptors.response.use(
      response => response,
      error => {
        if (error.response.status === 401) {
          //console.log("hi status 401" + error.response.status);
          return store.dispatch("logout");
        }
        //console.log("hi status" + error.response.status);
        return Promise.reject(error);
      }
    );
  },

  /**
   *
   * Global Statement
   *
   */

  async getLogin(credencial) {
    return await apiClient.post("/sys/v1/auth/d/login", credencial);
  },

  async resetPasswords(credencial) {
    return await apiClient.post("/sys/v1/auth/d/reset", credencial);
  },

  async recoverPasswords(credencial) {
    return await apiClient.post("/sys/v1/auth/d/recover", credencial);
  },
  async createNewPwd(credencial, vid) {
    return await apiClient.put("/sys/v1/auth/d/user/" + vid, credencial);
  },

  // async getProfile(id) {
  //   return await apiClient.get("/sys/v1/client/get" + id);
  // },
  //
  // async getCards() {
  //   return await apiClient.get("/users");
  // },

  /**
   * Statement One
   *
   */

  //Get Products and Category
  async getProductsToView() {
    return await apiClient.get("/sys/v1/cgs/service/get", {
      validateStatus: () => true
    });
  },

  async getCategoryToView(ref) {
    return await apiClient.get("/sys/v1/pds/service/search/" + ref, {
      validateStatus: () => true
    });
  },

  //Pay Service
  async getPayService(value) {
    // return await apiClient.post("/api/v1/payment/" + pos + "/" + email, value);
    // return await apiClient.post("/api/v1/payment/", value);
    return await apiClient.post("/sys/v1/bl/transaction/event/new", value);
  },

  //Client
  async getClients() {
    return await apiClient.post("/sys/v1/client/search/ud");
  },

  async getAvatar(payload) {
    return await clientFormData.post("/sys/v1/client/avatar", payload);
  },

  async updateProfile(payload) {
    return await apiClient.put("/sys/v1/client/up", payload);
  },

  async updatePwd(payload, vid) {
    return await apiClient.put("/sys/v1/auth/d/user/" + vid, payload);
  },

  async requestUpdateAndCreatePin(pwd) {
    return await apiClient.post("/sys/v1/client/up/pin", pwd);
  },

  //Transactions Client

  async getCTransactions(ref) {
    return await apiClient.get("/sys/v1/bl/transaction/search/client/" + ref, {
      validateStatus: () => true
    });
  },

  //Receipt
  async getPrintReceipt(ref) {
    return await bufferPDF.get("/sys/v1/r/transaction/get/document/" + ref, {
      validateStatus: () => true
    });
  },

  /**
   *
   * Wallet
   */
  async getBankAccounts() {
    return await apiClient.get("/sys/v1/kp/get/account");
  },
  async getTransactions() {
    return await apiClient.get("/sys/v1/kp/get/transactions");
  },

  async chargeWithWallets(value) {
    return await apiClient.post("/sys/v1/kp/charge", value);
  },

  async confirmTransferToWallets(value) {
    return await apiClient.post("/sys/v1/kp/search/account", value);
  },
  async transferToWallets(value) {
    return await apiClient.post("/sys/v1/kp/transfer", value);
  },

  /**
   * End wallet
   */

  /**
   * Statement Two
   *
   */

  //Entities getEntities
  async getEntities() {
    return await apiClient.get("/sys/v1/entity/e/get");
  },

  async updateProfileEntity(payload) {
    return await apiClient.post("/sys/v1/entity/e/up", payload);
  },

  async getAvatarEntity(payload) {
    return await clientFormData.post("/sys/v1/entity/e/avatar", payload);
  },

  async requestUpdateAndCreateEPin(pwd) {
    return await apiClient.post("/sys/v1/entity/create/pin", pwd);
    //check pin return await apiClient.post("/sys/v1/e/check/your/pin", pwd);
  },

  //Category

  async getCategories(ref) {
    return await apiClient.get("/sys/v1/own/service/search/" + ref, {
      validateStatus: () => true
    });
  },

  //Product
  async createProducts(value) {
    return await apiClient.post("/sys/v1/pdo/service/crt", value);
  },
  async editProducts(ref, value) {
    return await apiClient.put("/sys/v1/pdo/service/update/" + ref, value);
  },
  async deleteProducts(ref) {
    return await apiClient.delete("/sys/v1/pdo/service/delete/" + ref);
  },

  //Transactions

  async getETransactions(ref) {
    return await apiClient.get("/sys/v1/bl/transaction/search/ent/" + ref, {
      validateStatus: () => true
    });
  },

  //Message
  async sendMessageToOpenTickets(value) {
    return await apiClient.post("/sys/v1/stream/helper/client", value);
  },

  //Drop
  async dropClient() {
    return await apiClient.post("/sys/v1/client/drop");
  },
  async dropEntity(value) {
    return await apiClient.delete("/sys/v1/entity/e/drop", value);
  },

  //Connection

  async checkConn(value) {
    return await apiClient.post("/sys/v1/client/check/pin", value);
    // return await test.post("/api/v1/test", value);
  },

  /**
   * Bill
   */

  async getBillAggInvoice(value) {
    return await apiClient.get(
      "/sys/v1/b/billing/paramers/get/agg/inv/entity/" + value
    );
  },
  async openInvoiceUnpaid(value) {
    return await apiClient.post(
      "/sys/v1/b/billing/Paramers/get/invoice/by/status",
      value
    );
  },

  async getBReportToView(ref) {
    return await apiClient.get("/sys/v1/bl/transaction/get/balance/" + ref, {
      validateStatus: () => true
    });
  },
  async getChartTransactionEnt(ref) {
    return await apiClient.get("/sys/v1/bl/transaction/chart/get/" + ref, {
      validateStatus: () => true
    });
  },

  async getPrintInvoice(ref) {
    return await bufferPDF.get("/sys/v1/rt/transaction/get/invoice/" + ref, {
      validateStatus: () => true
    });
  },

  async getReportCSV(ref) {
    return await bufferCSV.post("/sys/v1/r/transaction/get/report", ref);
  }
};
